import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'sous-settings-template',
  templateUrl: './settings-template.component.html',
  styleUrls: ['./settings-template.component.scss']
})
export class SettingsTemplateComponent extends FieldType<FieldTypeConfig> implements OnInit {


  ngOnInit(): void {
  }

}
